import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IDataPanelViewModel } from '../../entities/view-model';
import { AuthService } from '../../services/auth.service';
import { IDataTableRowActionClickArg } from '../data-table-card/data-table-card.component';

@Component({
  selector: 'app-data-table-card-simple',
  templateUrl: './data-table-card-simple.component.html',
  styleUrls: ['./data-table-card-simple.component.scss']
})
export class DataTableCardSimpleComponent implements OnInit {

  constructor(private authService: AuthService) { }

  @Input() vm: IDataPanelViewModel;
  @Input() includeAction: boolean = false;
  @Input() keyColumn: number = -1;
  @Input() tableMaxHeight: number = undefined;

  @Output() rowActionClick = new EventEmitter<IDataTableRowActionClickArg>();

  ngOnInit(): void {
    console.log('ngOnInit');
    console.log(this.vm);
  }

  /**
   * 
   * @param vm 
   * @param rowCode 
   * @param actionCode 
   */
  onRowActionClick(vm: IDataPanelViewModel, rowCode: string, actionCode: string) {
    this.rowActionClick.emit({ vm: vm, rowCode: rowCode, actionCode: actionCode });
  }

  isContainArray(val: any): boolean {
    if (typeof val === "string") {
      if (String(val).includes('|'))
        return true;
    }
    return false;
  }
}
